// extracted by mini-css-extract-plugin
export default {"root_platform_desktop":"divkit-ee112","menu":"divkit-cedbe","menu_visible":"divkit-e4801","menu__list":"divkit-c8df2","menu__item":"divkit-ffd4a"};